'use client';

import { useState, useEffect } from 'react';

export interface AuthUser {
  id: string;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  displayName: string | null;
  profileImageUrl: string | null;
}

export function useAuth() {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isOwner, setIsOwner] = useState(false);

  useEffect(() => {
    fetch('/api/auth/user')
      .then(r => r.json())
      .then(data => {
        setUser(data);
        setIsLoading(false);
        if (data) {
          fetch('/api/auth/admin')
            .then(r => r.json())
            .then(admin => setIsOwner(admin.isOwner))
            .catch(() => {});
        }
      })
      .catch(() => setIsLoading(false));
  }, []);

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
    isOwner,
  };
}
